import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/service/common.service';
import { HttpService } from 'src/app/service/http.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-admin-login',
  templateUrl: './admin-login.component.html',
  styleUrls: ['./admin-login.component.scss']
})
export class AdminLoginComponent implements OnInit {
  params:any;
  constructor(private activatedRoute: ActivatedRoute, private httpService: HttpService, private toaster: ToastrService, private commonService: CommonService) {
    this.activatedRoute.queryParams.subscribe((values) => {
      this.params = values;
    })
  }

  ngOnInit() {
      this.httpService.customerAppLogin(this.params['audit'], this.params['id']).subscribe((data) => {
        if(data) {
          if (data['user']) {
            data["user"] = JSON.parse(this.commonService.decrypt(data['user']));
          }
          this.httpService.setCookies('user_id', data['user']['_id']);
          this.httpService.setCookies('token', data['accessToken']);
          this.httpService.setCookies('issec', 'true');
          this.httpService.setCookies('newAdminLogin', 'true');
          window.open(environment.appRedirectUri, '_self');
        } 
      }, (error) => {
        this.toaster.error(error && error.error.message ? error.error.message : 'Something went wrong')
      })
  }

}
